import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConvocatoriasRoutingModule } from './convocatorias-routing.module';
import { NuevaComponent } from './nueva/nueva.component';

@NgModule({
  imports: [
    CommonModule,
    ConvocatoriasRoutingModule,FormsModule,ReactiveFormsModule
  ],
  declarations: [NuevaComponent]
})
export class ConvocatoriasModule { }



// WEBPACK FOOTER //
// /app/src/app/modules/convocatorias/convocatorias.module.ts